import { axiosXhr } from './axiosXhr';
import { appLogout, REFRESH_TOKEN_FAIL } from './services/logout.js';
import axios from 'axios';

let requestInFlight = null;
const maxTiredTimes = 3;
let triedTimes = 0;

const makeRenewRequest = () => {
  const axiosSource = axios.CancelToken.source();
  requestInFlight = { cancel: axiosSource.cancel };
  axiosXhr({
    url: '/authentication/renew',
    method: 'POST',
    cancelToken: axiosSource.token,
  })
    .then(() => {
      requestInFlight = null;
      location.reload();
    })
    .catch(() => {
      triedTimes = triedTimes + 1;
      if (triedTimes < maxTiredTimes) {
        return makeRenewRequest();
      } else {
        appLogout(REFRESH_TOKEN_FAIL);
      }
      requestInFlight = null;
    });
};

const renewAccessToken = () => {
  if (requestInFlight === null) {
    makeRenewRequest();
  }
};

export default renewAccessToken;
